export default __webpack_public_path__ + "static/media/facebook-share-button.515f28dc.svg";